/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreAvailabilityResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreAvailabilityResponse(value) {
    if (!('Available' in value) || value['Available'] === undefined)
        return false;
    if (!('Games' in value) || value['Games'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreStoreAvailabilityResponseFromJSON(json) {
    return FxIdWebFeaturesStoreStoreAvailabilityResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreAvailabilityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Available': json['Available'],
        'Games': json['Games'],
    };
}
export function FxIdWebFeaturesStoreStoreAvailabilityResponseToJSON(json) {
    return FxIdWebFeaturesStoreStoreAvailabilityResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreAvailabilityResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Available': value['Available'],
        'Games': value['Games'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreStoreAvailabilityResponse.js.map